
@let loading = isVisualValid() && ((!data.loaded() && !data.failure()) || resetAgGrid());

<div class="table-visual-container" [class.loading]="loading">

  @if (canRender() && !resetAgGrid()) {
  @if (showRowCount()) {
    @let rc = rowCount();
    <div class="visual__row-count">
      <span class="mr-4">Total Rows:</span>
      @if (rc.loaded) {
        <span>{{rc.rowCount}}</span>
      }
      @else {
        <loading-rect size="35px 12px"></loading-rect>
      }
    </div>
  }
  <div class="ag-grid-table-container table-visual"
       [class.has-grand-total]="grandTotalsTable.enabled() && !grandTotalsTable.hidden()"
       [class.ag-grid-cell-navigation]="cellNavigationStarted()">
    <ag-grid-angular #agDataTable
                     class="ag-grid-table ag-grid-table-data table-visual__ag-data-table"
                     [gridOptions]="dataTable.ag.options()"

                     [theme]       ="dataTable.ag.theme()"
                     [getRowHeight]="dataTable.ag.getRowHeight"

                     [columnDefs]          ="dataTable.ag.columnDefs()"
                     [alignedGrids]        ="dataTable.ag.alignedGrids()"
                     [rowModelType]        ="'serverSide'"
                     [serverSideDatasource]="dataTable.data.source()?.serverSideDatasourceAdapter()"
                     [getRowId]            ="dataTable.ag.getRowId"

                     [getMainMenuItems]    ="agGridGetMainMenuItems"
                     [getContextMenuItems] ="agGridGetContextMenuItems"

                     (gridPreDestroyed)     ="dataTable.ag.gridReadyState.set(false)"
                     (gridReady)            ="dataTable.ag.gridReadyState.set(true)"
                     (firstDataRendered)    ="onAgGridFirstDataRendered($event)"
                     (sortChanged)          ="onAgGridSortChanged($event)"
                     (columnMoved)          ="onAgGridColumnMoved($event)"
                     (columnResized)        ="onAgGridColumnResized($event)"
                     (selectionChanged)     ="onAgGridSelectionChanged($event)"
                     (cellSelectionChanged) ="onAgGridCellSelectionChanged($event)"
                     (rowSelected)          ="onAgGridRowSelected($event)"
                     (cellKeyDown)          ="onAgGridCellKeyDown($event)"
                     (columnHeaderClicked)  ="onAgGridColumnHeaderClicked($event)"
                     >
    </ag-grid-angular>

    @if (grandTotalsTable.enabled()) {
      <ag-grid-angular #agGrandTotalsTable
                       class="ag-grid-table table-visual__ag-grand-total-table"
                       [hidden]="grandTotalsTable.hidden()"
                       [gridOptions]="grandTotalsTable.ag.options()"

                       [theme]       ="grandTotalsTable.ag.theme()"
                       [getRowHeight]="grandTotalsTable.ag.getRowHeight"

                       [columnDefs]  ="grandTotalsTable.ag.columnDefs()"
                       [alignedGrids]="grandTotalsTable.ag.alignedGrids()"
                       [rowModelType]="'clientSide'"
                       [rowData]     ="grandTotalsTable.ag.rowData()"

                       [getMainMenuItems]    ="agGridGetMainMenuItems_Totals"
                       [getContextMenuItems] ="agGridGetContextMenuItems_Totals"

                       (gridPreDestroyed) ="grandTotalsTable.ag.gridReadyState.set(false)"
                       (gridReady)        ="grandTotalsTable.ag.gridReadyState.set(true)"
                       (firstDataRendered)="grandTotalsTable.ag.firstDataRenderedState.set(true)"
                       >
      </ag-grid-angular>
    }
  </div>
  }

  @if (loading) {
    <div class="table-visual-loading-overlay">
      <app-spinner></app-spinner>
    </div>
  }
</div>
